/* Hero Slideshow + Overlay — autoplay / dots / arrows + auto-trim overlay image */
(function () {
  'use strict';

  /**
   * Auto-trim: loads the overlay image onto a canvas, finds the bounding box
   * of its non-transparent pixels, and re-renders it cropped to that box.
   * This guarantees the visible artwork always touches the image edges —
   * and therefore the section's border — no matter how much transparent
   * padding the original uploaded file has.
   */
  function autoTrimOverlayImage(img) {
    if (!img || img.dataset.trimmed === 'true') return;

    function trim(sourceImg) {
      var canvas = document.createElement('canvas');
      canvas.width = sourceImg.naturalWidth;
      canvas.height = sourceImg.naturalHeight;
      if (!canvas.width || !canvas.height) return;

      var ctx = canvas.getContext('2d');
      ctx.drawImage(sourceImg, 0, 0);

      var data;
      try {
        data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      } catch (err) {
        // Canvas got tainted (cross-origin image without CORS headers) —
        // silently skip trimming and keep the original image.
        return;
      }

      var w = canvas.width;
      var h = canvas.height;
      var top = null, bottom = null, left = null, right = null;
      var alphaThreshold = 8; // ignore near-fully-transparent pixels

      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var alpha = data[(y * w + x) * 4 + 3];
          if (alpha > alphaThreshold) {
            if (top === null) top = y;
            bottom = y;
            if (left === null || x < left) left = x;
            if (right === null || x > right) right = x;
          }
        }
      }

      // Nothing visible found (fully transparent image) — leave as-is.
      if (top === null) return;

      var trimmedWidth = right - left + 1;
      var trimmedHeight = bottom - top + 1;

      // Already tight to its edges — no need to re-render.
      if (left === 0 && top === 0 && right === w - 1 && bottom === h - 1) {
        img.dataset.trimmed = 'true';
        return;
      }

      var outCanvas = document.createElement('canvas');
      outCanvas.width = trimmedWidth;
      outCanvas.height = trimmedHeight;
      var outCtx = outCanvas.getContext('2d');
      outCtx.drawImage(canvas, left, top, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight);

      img.src = outCanvas.toDataURL('image/png');
      img.dataset.trimmed = 'true';
    }

    if (img.complete && img.naturalWidth) {
      trim(img);
    } else {
      img.addEventListener('load', function () {
        trim(img);
      }, { once: true });
    }
  }

  function initOverlayTrim(section) {
    var overlayImg = section.querySelector('.hero-slideshow__overlay-image');
    if (overlayImg) autoTrimOverlayImage(overlayImg);
  }

  function initHeroSlideshow(section) {
    initOverlayTrim(section);

    var slidesWrap = section.querySelector('[data-hero-slideshow-slides]');
    if (!slidesWrap) return;

    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-hero-slide]'));
    if (slides.length <= 1) return;

    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-hero-slideshow-dot]'));
    var prevBtn = section.querySelector('[data-hero-slideshow-prev]');
    var nextBtn = section.querySelector('[data-hero-slideshow-next]');
    var current = 0;
    var timer = null;
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed || '5', 10) * 1000;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplaySpeed || autoplaySpeed <= 0) return;
      stopAutoplay();
      timer = setInterval(next, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.hero-slideshow').forEach(initHeroSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector('.hero-slideshow');
    if (el) initHeroSlideshow(el);
  });
})();
